import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";

export default function DailyGridSkeleton() {
  return (
    <Box sx={{ padding: "8px 0" }}>
      <Skeleton variant="text" width={320} height={36} sx={{ mb: 2 }} />

      {/* Header summary */}
      <Paper sx={{ mb: 1.5 }}>
        <Stack spacing={1.5}>
          <Skeleton variant="rounded" width="40%" height={24} />
          <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} variant="rounded" width={130} height={44} />
            ))}
          </Box>
          <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} variant="rounded" width={260} height={90} />
            ))}
          </Box>
        </Stack>
      </Paper>

      {/* Grid */}
      <Paper>
        <Skeleton variant="rounded" width={220} height={32} sx={{ mb: 1 }} />
        <Box
          component="table"
          sx={{ width: "100%", borderCollapse: "collapse" }}
        >
          <tbody>
            {Array.from({ length: 12 }).map((_, r) => (
              <tr key={r}>
                {Array.from({ length: 14 }).map((__, c) => (
                  <td key={c} style={{ padding: 6 }}>
                    <Skeleton variant="text" height={22} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Box>
      </Paper>
    </Box>
  );
}
